import getParams from './getParams'
import cookies from './cookies'
import skey from './session/skey'
import pskey from './session/pskey'
import wechat from './session/wechat'
import dummy from './session/dummy'
import qqconnect from './session/qqconnect'

export default function getUrlSession() {
  let params = getParams()
  let sessiontype = params.sessiontype

  // 若url上没有 sessiontype 则直接返回 false
  if (!params.sessiontype) {
    return false
  }

  if (params.sessiontype !== 'skey' && !params.openid && !params.openkey) {
    return false
  }
  switch(true) {
    case sessiontype.indexOf('pskey_') > -1:
      return new pskey({
        uin: params.openid,
        pskey: params.openkey,
        sessiontype: sessiontype
      })

    case sessiontype === 'skey':
      return new skey({
        uin: cookies.get('uin').substr(1) * 1,
        skey: cookies.get('skey')
      })

    case sessiontype === 'kp_actoken':
      return new qqconnect({
        qq_appid: params.qq_appid,
        openid: params.openid,
        payToken: params.openkey
      })

    case sessiontype === 'kp_accesstoken':
      return new qqconnect({
        qq_appid: params.qq_appid,
        openid: params.openid,
        accessToken: params.openkey,
      })


    case sessiontype === 'wc_actoken':
      return new wechat({
        appid: params.wxAppid2 || 'wx951bdcac522929b6',
        openid: params.openid,
        accessToken: params.openkey
      })

    case sessiontype === 'st_dummy':
      return new dummy({
        openid: params.openid,
        openkey: params.openkey
      })

    default:
      return false
  }
}
